import React from 'react';
import { Button, Link as ComponentsLink } from '@fast-ai/ui-components';
import { Link } from 'gatsby-theme-fast-ai-sidebar';

/* eslint-disable react/prop-types */
const LinkButton = ({ to, variant = 'outline', ...rest }) => (
	<Button as={to ? Link : ComponentsLink} to={to} variant={variant} {...rest} />
);
export default LinkButton;
